// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6ebe6379","703":"3dff4721","787":"f4c4a45a"}[chunkId] + ".chunk.js";
};